var _rect, _path, _circle, _circle2, _circle3, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _circle4, _path2, _circle5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPainChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 50,
    width: 40,
    height: 26,
    rx: 11,
    fill: "#FDEBCB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 74l-2 9 10-7z",
    fill: "#FDEBCB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 63,
    r: 2.4,
    fill: "#E0A23A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 63,
    r: 2.4,
    fill: "#E0A23A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 63,
    r: 2.4,
    fill: "#E0A23A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 18,
    width: 78,
    height: 118,
    rx: 16,
    fill: "#FFFFFF",
    stroke: "#E4DCCF",
    strokeWidth: 2.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 28,
    width: 62,
    height: 98,
    rx: 8,
    fill: "#F7F2EA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 23,
    width: 16,
    height: 3,
    rx: 1.5,
    fill: "#E4DCCF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 42,
    width: 42,
    height: 20,
    rx: 9,
    fill: "#FFFFFF",
    stroke: "#E1E5EC",
    strokeWidth: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 49,
    width: 22,
    height: 3.6,
    rx: 1.8,
    fill: "#D8DEE7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 70,
    width: 42,
    height: 20,
    rx: 9,
    fill: "#F59E0B"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 77,
    width: 24,
    height: 3.6,
    rx: 1.8,
    fill: "#FCE3B5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 98,
    width: 34,
    height: 18,
    rx: 9,
    fill: "#FFFFFF",
    stroke: "#E1E5EC",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 30,
    r: 14,
    fill: "#F59E0B",
    stroke: "#FFFFFF",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M138 23.5c-3.2 0-5.3 2.2-5.3 5.5 0 3.6-1.4 4.6-1.4 4.6h13.4s-1.4-1-1.4-4.6c0-3.3-2.1-5.5-5.3-5.5z",
    fill: "#FFFFFF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 36.4,
    r: 1.8,
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPainChat);
export default __webpack_public_path__ + "static/media/pain-chat.5a8b100602acda10d925059828d20480.svg";
export { ForwardRef as ReactComponent };